import React, { ReactNode, createContext, useContext, useState } from 'react';
import { SearchListData } from '../search-list';

export type SearchListContextProps = {
  resultsHidden: boolean;
  hideResults: (bool?: boolean) => void;
} & SearchListData;

const SearchListContext = createContext<SearchListContextProps | undefined>(
  undefined
);

type SearchListProviderProps = {
  children: ReactNode;
} & SearchListData;

const SearchListProvider = ({
  children,
  ...props
}: SearchListProviderProps) => {
  const [resultsHidden, setResultsHidden] = useState(
    props.search.resultsHidden
  );

  const hideResults = (bool?: boolean) => {
    setResultsHidden((prev) => (typeof bool !== 'undefined' ? bool : !prev));
  };

  return (
    <SearchListContext.Provider
      value={{ ...props, resultsHidden, hideResults }}
    >
      {children}
    </SearchListContext.Provider>
  );
};

export const useSearchListContext = () => {
  const context = useContext(SearchListContext);
  if (context === undefined) {
    throw new Error('useSearchListContext must be within SearchListProvider');
  }

  return context;
};

export default SearchListProvider;
